// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"eb27559f","174":"caba173a","279":"a8cdac86","488":"c24af942","592":"9481ca52","610":"6ca9f366","708":"f368dfed","714":"f9c1ae14","811":"b81b4c77","837":"9f3c20ee"}[chunkId] + ".chunk.js";
};